import { useEffect, useState } from "react";

import { transformRetentionDataToSeriesLog } from "./constants";
import useAxios from "@hooks/use-axios";
import { useParams } from "react-router-dom";
import useSearchParams from "@hooks/use-search-params";

const useRetentionReport = () => {
    
    const { platformId } = useParams();
    const { axiosInstance, loading, cancelAllRequests } = useAxios({
        base         : "panel",
        initialLoader: true
    });
    const [data, setData] = useState({
        chart: {
            categories: [],
            series    : []
        },
        widgets: {
            averageNetRetentionRate: 0,
            netTotal               : 0,
            expansion              : 0,
            contractions           : 0,
            churn                  : 0
        }
    });
    
    const [queryParams, setQueryParams] = useState({});
    const { getSearchParams } = useSearchParams();
    
    const getRetentionReport = async () => {
        try {
            const { data } = await axiosInstance.get(`/report/${platformId}/retention`, {
                params: {
                    start: getSearchParams("start"),
                    end  : getSearchParams("end"),
                    ...queryParams
                }
            });
            
            const reportData = data?.report || [];
            const widgetData = data?.widget || {};
            const chartData = transformRetentionDataToSeriesLog(reportData);
                
            setData({
                chart  : chartData,
                widgets: {
                    averageNetRetentionRate: widgetData.average_net_retention_rate || 0,
                    netTotal               : widgetData.net_total || 0,
                    expansion              : widgetData.total_expansion_revenue || 0,
                    contractions           : widgetData.total_contraction_revenue || 0,
                    churn                  : widgetData.total_churn_revenue || 0
                }
            });
        } catch (error) {
            console.error("Error fetching retention report:", error);
        }
    };
    
    useEffect(() => {
        let isActive = true;
        if (isActive) {
            getRetentionReport();
        }
        return () => {
            isActive = false;
            cancelAllRequests();
        };
    }, [queryParams]);
    
    return {
        loading,
        data,
        setQueryParams,
        getRetentionReport
    };
};

export default useRetentionReport;